<template>
  <span class="loader" aria-label="Loading"></span>
</template>

<script>
  export default {
    name: 'LoadingSpinner'
  }
</script>

<style scoped>
  .loader {
    flex: none;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 2px solid var(--color-neutral-800);
    border-top-color: var(--color-accent);
    animation: spin 0.7s linear infinite;
  }
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
</style>
